var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"overlayObjectsControlBlock",staticClass:"moveable-overlay-objects-control",style:({ opacity: _vm.hidden ? 0 : 1 })},[_c('ResizeObserver',{on:{"notify":_vm.onResize}}),(_vm.mounted)?_c('div',{staticClass:"moveable-overlay-objects-control__inner"},_vm._l((_vm.overlays),function(overlay){return _c('Moveable',_vm._b({key:'moveable-overlay' + overlay.id,ref:'moveable-overlay' + overlay.id,refInFor:true,staticClass:"moveable",class:{
        _disabled:
          overlay.variationId !== _vm.previewItem.currentVariation.id || _vm.hidden,
        '_not-show': !_vm.isMoveableObjectInShowRange(overlay),
      },style:([
        overlay.moveabaleStyle,
        {
          transform: _vm.getOverlayTransform(overlay),
          alignItems: overlay.isRectangle ? 'start' : 'center',
        } ]),attrs:{"className":overlay.variationId !== _vm.previewItem.currentVariation.id || _vm.hidden
          ? 'moveable-control-box__disabled'
          : _vm.currentHoverOverlayId !== -1 &&
            _vm.currentHoverOverlayId !== overlay.id
          ? 'moveable-control-box__hidden'
          : '',"container":_vm.$refs.overlayObjectsControlBlock},on:{"dragStart":function (e) { return _vm.handleStartDrag(e, overlay); },"dragEnd":function (e) { return _vm.handleEndDrag(e, overlay); },"drag":function (e) { return _vm.handleDrag(e, overlay); },"resize":function (e) { return _vm.handleResize(e, overlay); },"scaleStart":function (e) { return _vm.handleStartScale(e, overlay); },"scaleEnd":function (e) { return _vm.handleEndScale(e, overlay); },"scale":function (e) { return _vm.handleScale(e, overlay); },"rotateEnd":function (e) { return _vm.handleEndRotate(e, overlay); },"rotate":function (e) { return _vm.handleRotate(e, overlay); },"snap":function (e) { return _vm.snap(e, overlay); },"warp":_vm.handleWarp,"pinch":_vm.handlePinch},nativeOn:{"mousedown":function($event){return _vm.openToolInToolsPanel('Overlays')},"mouseover":function($event){return _vm.onHover(overlay)},"mouseleave":function($event){return _vm.leaveHover(overlay)}}},'Moveable',overlay.moveableObject,false),[_c('div',{staticStyle:{"position":"absolute","display":"none"},attrs:{"id":'overlay' + overlay.id}}),(
          !_vm.isItTextObject(overlay) &&
          !_vm.isItShapeObject(overlay) &&
          !_vm.isItAnimationObject(overlay)
        )?_c('div',{staticStyle:{"position":"relative","display":"flex","width":"100%","height":"auto"},style:(_vm.getOverlayAnimationStyle(overlay))},[(
            !_vm.isItTextObject(overlay) &&
            overlay.type !== 'stock' &&
            overlay.type !== 'stock-video' &&
            overlay.file &&
            (overlay.file.type === 'image' ||
              (overlay.file.type === 'gif' &&
                (!overlay.file.pathWebm || _vm.isSafariBrowser)))
          )?_c('img',{class:{
            _height: overlay.file.w < overlay.file.h,
            _width: overlay.file.w >= overlay.file.h,
          },staticStyle:{"position":"relative"},style:({
            opacity:
              _vm.isSafariBrowser && overlay.file.type === 'gif'
                ? 0
                : overlay.alpha,
          }),attrs:{"preload":"auto","src":_vm.$baseURL + overlay.file.path},on:{"load":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}):_vm._e(),(
            !_vm.isItTextObject(overlay) &&
            overlay.type !== 'stock' &&
            overlay.type !== 'stock-video' &&
            overlay.file &&
            (overlay.file.type === 'video' ||
              (overlay.file.type === 'gif' &&
                overlay.file.pathWebm &&
                !_vm.isSafariBrowser))
          )?_c('video',{class:{
            _height: overlay.file.w < overlay.file.h,
            _width: overlay.file.w >= overlay.file.h,
          },staticStyle:{"position":"relative"},style:({ opacity: overlay.alpha }),attrs:{"muted":"","loop":"","preload":"auto","src":_vm.$baseURL +
            (overlay.file.type === 'video'
              ? overlay.file.path
              : overlay.file.pathWebm)},domProps:{"muted":true},on:{"canplay":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}):_vm._e(),(
            overlay.file &&
            overlay.type !== 'stock' &&
            overlay.type !== 'stock-video' &&
            (_vm.isSafariBrowser || !overlay.file.pathWebm) &&
            overlay.file.type === 'gif'
          )?_c('BaseGifPlayer',{ref:'gif' + overlay.id,refInFor:true,staticStyle:{"position":"absolute","width":"100%","height":"100%"},style:({ opacity: overlay.alpha }),attrs:{"src":_vm.$baseURL + overlay.file.path,"paused":!_vm.isPlaying}}):_vm._e(),(
            !_vm.isItTextObject(overlay) &&
            overlay.type === 'stock' &&
            overlay.type !== 'stock-video' &&
            overlay.file &&
            overlay.file.systemMethod !== 'pixabay'
          )?_c('img',{class:{
            _height: overlay.file.width < overlay.file.height,
            _width: overlay.file.width >= overlay.file.height,
          },staticStyle:{"position":"relative"},style:({ opacity: overlay.alpha }),attrs:{"preload":"auto","src":(overlay.file.paid ? '' : _vm.$baseURL) + overlay.file.preview},on:{"load":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}):_vm._e(),(
            !_vm.isItTextObject(overlay) &&
            overlay.type === 'stock' &&
            overlay.type !== 'stock-video' &&
            overlay.file &&
            overlay.file.systemMethod === 'pixabay'
          )?_c('img',{class:{
            _height: overlay.file.w < overlay.file.h,
            _width: overlay.file.w >= overlay.file.h,
          },staticStyle:{"position":"relative"},style:({ opacity: overlay.alpha }),attrs:{"preload":"auto","src":overlay.file.download},on:{"load":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}):_vm._e(),(overlay.type === 'stock-video')?_c('video',{staticClass:"overlay-card__main-block__preview__box__image",class:{
            _height: overlay.file.w < overlay.file.h,
            _width: overlay.file.w >= overlay.file.h,
          },style:({ opacity: overlay.alpha }),attrs:{"muted":"","loop":"","preload":"auto","src":overlay.file.path},domProps:{"muted":true},on:{"canplay":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}):_vm._e()],1):_vm._e(),(_vm.isItTextObject(overlay) && !overlay.isRectangle)?_c('div',{staticClass:"gradient-multiline",style:([
          {
            textAlign: overlay.style.paragraph,
            margin:
              overlay.style.box.width +
              'px ' +
              (10 + overlay.style.box.width) +
              'px',
          },
          _vm.getOverlayAnimationStyle(overlay) ])},[_c('span',{style:({
            color: 'transparent',
            fontSize: overlay.style.size.name,
            fontWeight: overlay.style.fontWeight,
            fontFamily: overlay.style.font.name,
            fontStyle: overlay.style.fontStyle,
            textDecoration: overlay.style.isUnderline ? 'underline' : 'none',
            textShadow: 'none',
            lineHeight: 'calc(' + overlay.style.height.name + ' - 0px)',
            height: overlay.style.height.name,
            background: overlay.style.box.show
              ? _vm.getLineBackground(overlay)
              : 'transparent',
            boxShadow: _vm.getLineBoxShadow(overlay),
            opacity: 0,
          })},[_vm._v(_vm._s(overlay.value))]),_c('canvas',{ref:'textBoxCanvas' + overlay.id,refInFor:true,staticStyle:{"position":"absolute","top":"0","left":"-10px"},style:({
            position: 'absolute',
            top: -overlay.style.box.width + 'px',
            left: -10 - overlay.style.box.width + 'px',
            opacity: 0,
            pointerEvents: 'none',
          }),attrs:{"width":"0","height":"0"}}),_c('img',{ref:'textBoxImage' + overlay.id,refInFor:true,style:({
            position: 'absolute',
            top: -overlay.style.box.width + 'px',
            left: -10 - overlay.style.box.width + 'px',
            width:
              'calc(100% + ' + 2 * (10 + overlay.style.box.width) + 'px)',
            height: 'calc(100% + ' + 2 * overlay.style.box.width + 'px)',
          })}),_c('span',{style:({
            color: overlay.style.color,
            fontSize: overlay.style.size.name,
            fontWeight: overlay.style.fontWeight,
            fontFamily: overlay.style.font.name,
            fontStyle: overlay.style.fontStyle,
            textDecoration: overlay.style.isUnderline ? 'underline' : 'none',
            textShadow: 'none',
            lineHeight: 'calc(' + overlay.style.height.name + ' - 0px)',
            height: overlay.style.height.name,
            background: 'transparent',
            boxShadow: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
          }),on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.clickToEdit($event)},"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.mousedown($event)},"keydown":[function($event){$event.stopPropagation();return (function () {})($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return (function (e) { return _vm.enterNewLine(e, overlay); })($event)}],"keyup":function($event){$event.stopPropagation();return (function () {})($event)},"input":function (e) { return _vm.changeText(e, overlay); },"blur":function (e) { return _vm.blur(e, overlay); }}},[_vm._v(_vm._s(overlay.value))])]):_vm._e(),(_vm.isItTextObject(overlay) && overlay.isRectangle)?_c('div',{staticClass:"gradient-multiline",style:([
          {
            textAlign: overlay.style.paragraph,
            height: '100%',
            justifyContent:
              overlay.style.paragraph === 'left'
                ? 'flex-start'
                : overlay.style.paragraph === 'right'
                ? 'flex-end'
                : overlay.style.paragraph,
            background: overlay.style.box.show
              ? _vm.getLineBackground(overlay)
              : 'transparent',
            display: 'flex',
            alignItems: 'center',
          },
          _vm.getOverlayAnimationStyle(overlay) ])},[_c('span',{style:({
            color: overlay.style.color,
            fontSize: overlay.style.size.name,
            fontWeight: overlay.style.fontWeight,
            fontFamily: overlay.style.font.name,
            fontStyle: overlay.style.fontStyle,
            textDecoration: overlay.style.isUnderline ? 'underline' : 'none',
            textShadow: 'none',
            lineHeight: 'calc(' + overlay.style.height.name + ' - 0px)',
            background: 'transparent',
            boxShadow: 'none',
            position: 'absolute',
            whiteSpace: 'break-spaces',
            wordBreak: 'break-all',
            padding:
              overlay.style.box.width +
              'px ' +
              (10 + overlay.style.box.width) +
              'px',
            margin: '0px',
          }),on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.clickToEdit($event)},"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.mousedown($event)},"keydown":function($event){$event.stopPropagation();return (function () {})($event)},"input":function (e) { return _vm.scaleOverlayRectangleTextFontSize(overlay); },"blur":function (e) { return _vm.blur(e, overlay); }}},[_vm._v(_vm._s(overlay.value))])]):_vm._e(),(_vm.isItShapeObject(overlay))?_c('div',{staticStyle:{"position":"relative","display":"flex","width":"auto","height":"auto"},style:(_vm.getOverlayAnimationStyle(overlay))},[_c('img',{staticStyle:{"position":"relative","opacity":"0","width":"100%","height":"100%"},attrs:{"preload":"auto","src":_vm.$baseURL + overlay.file.path},on:{"load":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}),_c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute","object-fit":"contain"},style:({
            maskImage: 'url(' + (_vm.$baseURL + overlay.file.path) + ')',
            maskSize: 'contain',
            maskRepeat: 'no-repeat',
            maskPosition: 'center',
            backgroundColor: overlay.style.color,
            opacity: overlay.alpha,
          })})]):_vm._e(),(_vm.isItAnimationObject(overlay))?_c('div',{staticStyle:{"position":"relative","display":"flex","width":"auto","height":"auto"},style:(_vm.getOverlayAnimationStyle(overlay))},[_c('img',{staticStyle:{"position":"relative","opacity":"0","width":"100%","height":"100%"},attrs:{"preload":"auto","src":overlay.file.image},on:{"load":function($event){return _vm.updateMoveableRect('overlay', overlay.id)}}}),_c('BaseAnimation',{ref:'animation' + overlay.id,refInFor:true,staticStyle:{"width":"100%","height":"100%","position":"absolute","object-fit":"contain"},style:({
            opacity: overlay.alpha,
          }),attrs:{"json":overlay.file.json,"autoplay":false,"paused":!_vm.isPlaying}})],1):_vm._e()])}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }